import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const SR_TOOLTIP_ICON_QUESTION_MARK = 'icon-questionMark';
export const SR_TOOLTIP_ICON_PEOPLE = 'icon-people';

const SR_TOOLTIP_ICONS = [
  SR_TOOLTIP_ICON_QUESTION_MARK,
  SR_TOOLTIP_ICON_PEOPLE,
];

export const SR_TOOLTIP_POSITION_LEFT = 'position-left';
export const SR_TOOLTIP_POSITION_CENTER = 'position-center';
export const SR_TOOLTIP_POSITION_CENTER_UNDERNEATH = 'position-center-underneath';

export const SR_TOOLTIP_POSITIONS = [
  SR_TOOLTIP_POSITION_LEFT,
  SR_TOOLTIP_POSITION_CENTER,
  SR_TOOLTIP_POSITION_CENTER_UNDERNEATH,
];

export const SR_TOOLTIP_BG_COLOR_TO_CLASSNAME_MAPPING = {
  blue: 'bg-color-blue',
  blueBright: 'bg-color-blue-bright',
  orange600: 'bg-color-orange600',
  green: 'bg-color-green',
  'green-dark': 'bg-color-green-dark',
  red: 'bg-color-red',
};

const SrTooltip = ({
  label,
  iconName,
  icon,
  children,
  position,
  bgColor,
  className,
  tooltipContentStyle,
}) => (
  <span
    className={classnames(
      'SrTooltip',
      SR_TOOLTIP_BG_COLOR_TO_CLASSNAME_MAPPING[bgColor],
      iconName,
      position,
      className,
    )}
  >
    {label && (
      <span className='tooltipLabel'>{label}</span>
    )}
    {icon || <span className='tooltipIcon' />}
    <span className='tooltipContent' style={tooltipContentStyle}>
      {children}
    </span>
  </span>
);

SrTooltip.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.node,
  icon: PropTypes.node,
  iconName: PropTypes.oneOf(SR_TOOLTIP_ICONS),
  position: PropTypes.oneOf(SR_TOOLTIP_POSITIONS),
  bgColor: PropTypes.oneOf(Object.keys(SR_TOOLTIP_BG_COLOR_TO_CLASSNAME_MAPPING)),
  tooltipContentStyle: PropTypes.object,
};

SrTooltip.defaultProps = {
  iconName: SR_TOOLTIP_ICON_QUESTION_MARK,
  position: SR_TOOLTIP_POSITION_CENTER,
};

SrTooltip.displayName = 'SrTooltip';

export default SrTooltip;
